/**
 * Values of the external vehicle filters above the calendar. Every filter is a multiselect of
 * catalogue enum keys (or codelist ids); an empty array means "no restriction".
 */
export interface RentalCalendarFilterValues {
  vehicleId: string[];
  vehicleCategory: string[];
  carPark: string[];
  vehicleType: string[];
  make: string[];
  modelFamily: string[];
  bodyStyle: string[];
  fuelType: string[];
  transmission: string[];
  drive: string[];
  doorCount: string[];
  seatCount: string[];
}

export const EMPTY_RENTAL_CALENDAR_FILTERS: RentalCalendarFilterValues = {
  vehicleId: [],
  vehicleCategory: [],
  carPark: [],
  vehicleType: [],
  make: [],
  modelFamily: [],
  bodyStyle: [],
  fuelType: [],
  transmission: [],
  drive: [],
  doorCount: [],
  seatCount: [],
};
